import React from 'react';
import PropTypes from 'prop-types';

export default function StepTab({ total, current }) {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb d-flex">
        {[...Array(total)].map((item, i) => (
          /* eslint-disable react/no-array-index-key */
          <li
            key={i}
            className={`breadcrumb-item flex-grow-1 ${i + 1 <= current ? 'active' : ''}`}
            aria-current="page"
          >
            <span>
              <span className="d-none d-md-inline pe-1">Step</span>
              {i + 1}
            </span>
          </li>
          /* eslint-enable react/no-array-index-key */
        ))}
      </ol>
    </nav>
  );
}

StepTab.propTypes = {
  total: PropTypes.number.isRequired,
  current: PropTypes.number,
};

StepTab.defaultProps = {
  current: null,
};
